import * as React from 'react';

export const RememberCheckSvg: React.FC = () => {
  return (
    <svg width={12} height={12} fill='none'>
      <path
        stroke='#222'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
        d='M10 3 4.5 8.5 2 6'
      />
    </svg>
  );
};
